/* Nutrishop v17 (23.10.2026): podsjetnik „U korpi“, jasnija dostava u korpi,
   detalji o dostavi na proizvodu i zoom na dodir slike. Markup i stil: snippets/ns-v17.liquid.
   Clarity događaji za mjerenje: v17_cartbar_open, v17_cartbar_checkout, v17_strip_open, v17_sticky_checkout,
   v17_incart_checkout, v17_delivery_info, v17_image_zoom. */
(() => {
  'use strict';
  const read = id => { try { return JSON.parse(document.getElementById(id).textContent); } catch { return {}; } };
  const ns = read('ns-config');
  const v17 = read('ns-v17-config');
  const root = (ns.root || '/').replace(/\/?$/, '/');
  const threshold = Number(ns.threshold || 0);
  const shippingCost = Number(ns.shippingCost || 0);
  const money = value => { try { return new Intl.NumberFormat('sr-Latn-ME', {style: 'currency', currency: ns.currency || 'EUR'}).format(Number(value || 0) / 100); } catch { return (Number(value || 0) / 100).toFixed(2).replace('.', ',') + ' €'; } };
  const euro = value => '€' + (Number(value || 0) / 100).toFixed(2).replace('.', ',');
  const plural = n => (n % 10 === 1 && n % 100 !== 11) ? 'proizvod' : 'proizvoda';
  const track = name => { try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch {} };
  const costs = cart => {
    const total = Number(cart.total_price || 0);
    const free = threshold > 0 && total >= threshold;
    const ship = free ? 0 : shippingCost;
    return {total, free, ship, pay: total + ship, remaining: threshold > 0 ? Math.max(0, threshold - total) : 0};
  };

  /* Okvirni datum isporuke: „obično X–Y radnih dana“ od danas, bez vikenda */
  const range = (String(v17.delivery || '').match(/(\d+)\D+(\d+)/) || [0, 1, 3]).slice(1, 3).map(Number);
  const dayNames = ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'];
  const businessDay = n => { const d = new Date(); let added = 0; while (added < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) added++; } return d; };
  const dayLabel = d => dayNames[d.getDay()] + ' ' + d.getDate() + '.' + (d.getMonth() + 1) + '.';
  const deliveryWindow = () => dayLabel(businessDay(range[0])) + ' i ' + dayLabel(businessDay(range[1]));

  const product = () => document.querySelector('[data-ns-product]');
  const selectedVariant = p => { const input = p && p.querySelector('form.ns-product-form [name="id"]'); return input ? Number(input.value) : 0; };
  const activeSticky = () => { const p = product(); const mb = p && p.querySelector('.mobile-buy'); return mb && getComputedStyle(mb).display !== 'none' ? mb : null; };
  let lastCart = v17.cart && Array.isArray(v17.cart.items) ? v17.cart : null;

  /* ---------- Traka „U korpi“ ---------- */
  function cartBar(cart, count, c, sticky) {
    const bar = document.getElementById('ns-cartbar');
    if (!bar) return;
    const show = count > 0 && !document.querySelector('[data-ns-cart-page]') && !sticky;
    bar.hidden = !show;
    document.body.classList.toggle('ns-cartbar-on', show);
    if (!show) return;
    const label = bar.querySelector('[data-ns-v17-count]');
    const total = bar.querySelector('[data-ns-v17-total]');
    if (label) label.textContent = 'U korpi: ' + count + ' ' + plural(count);
    if (total) total.innerHTML = money(c.total) + ' · <u>Pogledaj korpu</u>';
  }

  /* Na stranici proizvoda (telefon): traka za kupovinu zna šta je već u korpi */
  function stickyMode(mb, cart, count, c) {
    const p = product();
    const vid = selectedVariant(p);
    const inCart = !!vid && cart.items.some(item => Number(item.variant_id) === vid);
    const button = mb.querySelector('button[name="add"]');
    const canSwitch = inCart && button && !button.disabled;
    mb.classList.toggle('ns-v17-incart', canSwitch);
    const label = mb.querySelector('[data-ns-add-label]');
    if (label && button && !button.disabled) label.textContent = canSwitch ? 'Nastavi na plaćanje' : 'Dodaj u korpu';
    const small = mb.querySelector('small');
    let badge = small && small.querySelector('.ns-mb-incart');
    if (small && canSwitch && !badge) { badge = document.createElement('span'); badge.className = 'ns-mb-incart'; badge.textContent = '✓ U korpi · '; small.prepend(badge); }
    if (badge && !canSwitch) badge.remove();
    let strip = mb.querySelector('.ns-mb-strip');
    const showStrip = count > 0 && !canSwitch;
    if (showStrip && !strip) {
      strip = document.createElement('button');
      strip.type = 'button';
      strip.className = 'ns-mb-strip';
      strip.dataset.nsOpen = 'ns-cart';
      strip.dataset.nsV17Track = 'v17_strip_open';
      mb.prepend(strip);
    }
    if (strip) {
      strip.hidden = !showStrip;
      if (showStrip) strip.innerHTML = '<span>U korpi: <b>' + count + ' ' + plural(count) + ' · ' + money(c.total) + '</b></span><span class="ns-mb-strip-cta">Pogledaj korpu ›</span>';
    }
    mb.classList.toggle('ns-v17-has-strip', showStrip);
  }

  /* Ispod glavnog dugmeta: kratka napomena kad je izabrano pakovanje već u korpi */
  function inCartNote(cart) {
    const p = product();
    const row = p && p.querySelector('#ns-buy-row');
    if (!row) return;
    const vid = selectedVariant(p);
    const inCart = !!vid && cart.items.some(item => Number(item.variant_id) === vid);
    let note = p.querySelector('.ns-v17-incart-note');
    if (inCart && !note) {
      note = document.createElement('p');
      note.className = 'ns-v17-incart-note';
      note.innerHTML = '✓ Ovaj proizvod je u korpi. <a href="' + root + 'checkout" data-ns-v17-track="v17_incart_checkout">Nastavi na plaćanje →</a>';
      row.after(note);
    }
    if (note) note.hidden = !inCart;
  }

  function render(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;
    const count = Number(cart.item_count || 0);
    const c = costs(cart);
    const sticky = activeSticky();
    cartBar(cart, count, c, sticky);
    if (sticky) stickyMode(sticky, cart, count, c);
    inCartNote(cart);
  }

  /* ---------- Korpa (bočna i stranica /cart) ---------- */
  function miniPrice(mini) {
    const el = mini.querySelector('.ns-mini-price');
    if (!el) return 0;
    const first = el.firstChild && el.firstChild.nodeType === 3 ? el.firstChild.textContent : el.textContent;
    const value = Number(first.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
    return Number.isFinite(value) ? Math.round(value * 100) : 0;
  }
  function sortCross(box) {
    const near = Number(box.dataset.nsV17Near || 0);
    const list = box.querySelector('[data-ns-cross-list]');
    if (!list || !near) return;
    const items = [...list.children];
    const key = mini => { const price = miniPrice(mini); return price >= near ? price : 1e7 + price; };
    const sorted = items.slice().sort((a, b) => key(a) - key(b));
    if (sorted.every((mini, i) => mini === items[i])) return;
    sorted.forEach(mini => list.appendChild(mini));
  }
  /* Stranica /cart prikazuje cijene kao „€21,20“ (Liquid), bočna korpa kao „21,20 €“; isti format unutar istog bloka */
  const priceIn = el => (el.closest('.ns-cart-totals, [data-ns-cart-page]') ? euro : money);
  const watched = new WeakSet();
  function crossSell(c) {
    document.querySelectorAll('#ns-cart-cross, .ns-cart-cross').forEach(box => {
      let title = box.querySelector('.ns-v17-cross-title');
      if (!title) { title = document.createElement('p'); title.className = 'ns-v17-cross-title'; box.prepend(title); }
      const near = !c.free && c.remaining > 0 && c.remaining <= 1000;
      title.textContent = near ? 'Fali još ' + priceIn(box)(c.remaining) + ' do besplatne dostave:' : 'Uz ovo kupci često uzmu:';
      box.dataset.nsV17Near = near ? String(c.remaining) : '';
      const list = box.querySelector('[data-ns-cross-list]');
      if (list && !watched.has(list) && window.MutationObserver) { watched.add(list); new MutationObserver(() => sortCross(box)).observe(list, {childList: true}); }
      sortCross(box);
    });
  }
  function cartSummary(cart) {
    const c = costs(cart);
    document.querySelectorAll('#ns-cart-summary .cart-total > span:first-child, .ns-cart-totals .cart-total > span:first-child').forEach(el => { el.textContent = 'Proizvodi'; });
    document.querySelectorAll('[data-ns-shipping-cost]').forEach(el => { el.innerHTML = '<span>Dostava</span><b>' + (c.free ? 'besplatna' : priceIn(el)(c.ship)) + '</b>'; });
    document.querySelectorAll('[data-ns-cod-total]').forEach(el => { el.innerHTML = '<span>Plaćaš kuriru pri preuzimanju</span><b>' + priceIn(el)(c.pay) + '</b>'; });
    document.querySelectorAll('[data-ns-shipping-message]').forEach(el => { const f = priceIn(el); el.textContent = c.free ? 'Dostava je besplatna.' : 'Besplatna dostava od ' + f(threshold) + ' · fali još ' + f(c.remaining); });
    document.querySelectorAll('#ns-cart-summary .ns-cod-note, .ns-cart-totals .ns-cod-note').forEach(el => { el.textContent = 'Stiže obično između ' + deliveryWindow() + ' · Plaćanje pouzećem · Fiskalni račun'; });
    crossSell(c);
  }

  /* ---------- Stranica proizvoda: blok o dostavi otvara detalje ---------- */
  function openDialog(id) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    if (!dialog.open) { dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
    return true;
  }
  function trustBlocks() {
    document.querySelectorAll('.detail-trust').forEach(list => {
      if (list.dataset.nsV17) return;
      list.dataset.nsV17 = 'true';
      list.classList.add('ns-v17-trust');
      list.setAttribute('role', 'button');
      list.setAttribute('aria-haspopup', 'dialog');
      list.setAttribute('aria-label', 'Dostava i plaćanje: detalji');
      list.tabIndex = 0;
      const first = list.querySelector('li span');
      if (first && shippingCost > 0 && threshold > 0 && /besplatno/i.test(first.textContent)) {
        first.innerHTML = 'Dostava ' + (v17.delivery || '1–3 radna dana') + ' · ' + euro(shippingCost) + ', <strong>besplatno od ' + euro(threshold) + '</strong>';
      }
      const more = document.createElement('li');
      more.className = 'ns-v17-trust-more';
      more.textContent = 'Detalji o dostavi i plaćanju ›';
      list.append(more);
    });
  }

  /* ---------- Događaji ---------- */
  document.addEventListener('cart:updated', event => {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    render(cart);
    cartSummary(cart);
  });
  document.addEventListener('variant:change', () => { if (lastCart) render(lastCart); });
  document.addEventListener('click', event => {
    const stickyCheckout = event.target.closest('.mobile-buy.ns-v17-incart button[name="add"]');
    if (stickyCheckout) { event.preventDefault(); track('v17_sticky_checkout'); location.assign(root + 'checkout'); return; }
    const tracked = event.target.closest('[data-ns-v17-track]');
    if (tracked) track(tracked.dataset.nsV17Track);
    const trust = event.target.closest('.ns-v17-trust');
    if (trust && openDialog('ns-delivery')) { track('v17_delivery_info'); return; }
    const image = event.target.closest('.gallery-stage .ns-media img');
    if (image) { const zoom = image.closest('.ns-media').querySelector('[data-ns-zoom]'); if (zoom) { zoom.click(); track('v17_image_zoom'); } return; }
    const info = event.target.closest('.mobile-buy > div');
    if (info) { const p = product(); if (p) p.scrollIntoView({behavior: 'smooth', block: 'start'}); }
  }, true);
  document.addEventListener('keydown', event => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.classList && event.target.classList.contains('ns-v17-trust')) {
      event.preventDefault();
      if (openDialog('ns-delivery')) track('v17_delivery_info');
    }
  });
  let resizeTimer;
  window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => { if (lastCart) render(lastCart); }, 200); });
  document.addEventListener('shopify:section:load', () => { trustBlocks(); if (lastCart) render(lastCart); });
  trustBlocks();
  if (lastCart) render(lastCart);
})();
